export default "__VITE_ASSET__S4gyT3DK__"